import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'

import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'


import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'

import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'


import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'
import { ReactComponent as Baskett } from '../../../../../assets/zarahome/LittleBasket.svg'
import { ReactComponent as Object } from '../../../../../assets/zarahome/objects.svg'
import { ReactComponent as Textile } from '../../../../../assets/zarahome/textile.svg'
import { ReactComponent as FoodContact } from '../../../../../assets/zarahome/foodcontact.svg'

import { ReactComponent as Cont } from '../../../../../assets/zarahome/cont.svg'

import { ReactComponent as Pieces } from '../../../../../assets/zarahome/pieces.svg'
import { ReactComponent as Eac } from '../../../../../assets/zarahome/eac.svg'

import { ReactComponent as Reg } from '../../../../../assets/zarahome/reg.svg'

import { ReactComponent as Papx } from '../../../../../assets/zarahome/pap.svg'

import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import QRCodeComponent from './qrcodecomponent'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCMKIDS from './RenderIndoItemsCMKIDS'
import { dataTagSymbol } from '@tanstack/react-query'

export default function Page2Kids({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  integerPart,
  decimalPart,
x,
y,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")

  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  const [brand, category, subCategory] = department ? department.split(' / ') : ['', '', '']
 
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "5.166mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "5.166mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "5.166mm", height: "auto" },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  function getProductTextById(id) {
    const matchedProduct = homeProducts.find(item => item.id === id);



    return matchedProduct ? matchedProduct.text : "";


  }
  
  useEffect(() => {


    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak

  useEffect(() => {


if(cardType === "Basket")
{
  const svgElement2 = barcodeRef.current?.querySelector('svg');
  const textElement2 = svgElement2?.querySelector('text');
  if (textElement2) {
    textElement2.style.letterSpacing = '0';
    textElement2.setAttribute('x', '55.1');
    textElement2.setAttribute('y', '33.2');
  }
}
    else if(cardType === "Object" || cardType === "Textile" || cardType === "Food contact")
    {
      const svgElement2 = barcodeRef.current?.querySelector('svg');
      const textElement2 = svgElement2?.querySelector('text');
      if (textElement2) {
        textElement2.style.letterSpacing = '0';
        textElement2.setAttribute('x', '51.4');
        textElement2.setAttribute('y', '31.1');
      }
    }
   
  }, [ barcodeRef]);  // barcodeValue veya isBlack değiştiğinde bu kod bloğunu çalıştır



  const renderSVG = (integer3, decimal3, integer4, decimal4) => {

    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape

  const renderCardTypeContent = () => {
    switch (cardType) {
      case "Textile":
        return (
          <div>
          <div>
            <div>
            <div
                style={{
                  position: 'absolute',
                  top: x+100,
                  left: y-15,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
            <Object width="45mm" height="auto" style={{position:"absolute",top:0,left:24,opacity:1}}/>
            <div
                style={{
                  position: 'absolute',
                  top: 113,
                  right: 36.2,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="5.2mm" height="auto"  />
                )}
              </div>

              <div style={{position:"absolute",top:301,left:35}}>
              <Eac width="5mm" height="auto" />


              </div>
              <div style={{position:"absolute",top:309,right:33,display:"flex",justifyContent:"flex-end",alignItems:"center",width:50,height:15}}>
              <Cont width="3.235mm" height="auto" style={{marginTop:10}}/>

              <p className="zara-regular" style={{fontSize:"14pt",marginRight:2,marginLeft:1,marginBottom:-3}}>{sizeData.piecesNumber?.replace(/\s*x\s*/g, 'x')}</p>
              <Pieces width="3.922mm" height="auto" />

              </div>
    
<div
className="pdf-force"
style={{
  position: 'absolute',
  top: 197.4,
  left: 36.5,
  width: '143px',
  // debug için:
  // backgroundColor: 'rgba(255,0,0,0.15)',
}}
>
{/* İÇ KATMAN: yatay bastırma + genişlik telafisi */}
<div
  className="text-[3.5pt] leading-[3.8pt] text-justify pdf-force"
  style={{
    fontWeight: 400,
    fontSize: '3.8pt',
    lineHeight: '3.5pt',
    letterSpacing: '-0.25px',
    textAlign: 'justify',
    textJustify: 'inter-word',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    wordSpacing: '-0.3px',
    overflowWrap: 'break-word',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',


    // varsayılan dar yapı
    transform: 'scaleX(0.73) scaleY(1.13)',
    transformOrigin: 'left top',
    width: 'calc(143px / 0.73)',
  }}
>
  {/* description → kalsın */}
  <div style={{ display: 'block', marginBottom: '4.3px' }}>
    {getProductTextById(sizeData.description)}
  </div>

  {/* orta blok → daha geniş */}


  {/* country translate → daha geniş */}

</div>






</div>
   <div style={{position:"absolute",top:249.3,height:29,left:24.4,width:"169px",display:"flex",justifyContent:"center",alignItems:"center"}}>
    <p className="arial-bold"
                    style={{
                      fontSize: "10.1pt",
                      lineHeight: "12pt",
                      letterSpacing: "0",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "10.1pt",
                      lineHeight: "12pt",
                      letterSpacing: "0",
                      color: "black",
                     marginLeft:3.8
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>

  <div
              style={{
                position: 'absolute',
                top: 7.5,
                left: 107.2,
                display: 'flex', // Flexbox kullanımı
      justifyContent: 'center', // Yatayda ortalama
      alignItems: 'center', // Dikeyde ortalama
      width:"30px",
      height:"30px",
  
              }}
            >

    
          <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexWrap: "nowrap",
    transition: "transform 0.3s ease",
    position: "absolute",
    width:82,

    top: 125.4,
    left:-7,
    height:25,

  }}
>
        <p
          className="arial-bold"
          style={{ marginRight: "4px",marginBottom:-6,marginLeft:-2.4 ,fontSize:"8pt"}}
        >
         EUR
        </p>
        <p
className='arial-regular'
style={{
  fontSize: "14pt",
  letterSpacing: "0",
  marginTop:"1px",
}}
>
       {integerPart}

        </p>
    {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
          <p
            className="arial-regular"
            style={{
              fontSize: "8pt",
              marginTop: "-5px",
              marginLeft: "1.8px",

              letterSpacing:"0"
            }}
          >
           {decimalPart}
          </p>
        )}
      </div>
    
              </div>
        
              
              <div></div>
           
    

     
         
    
             
              <div style={{ position: 'absolute', top: 111, left: 81 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>

    
         
     
              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 155.7, left: 76.8,width:"29.453mm",height:"11.971mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.767}
                  height={22.6}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={2}
                  fontSize={6.8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
           
            </div>
          </div>
        </div>
        );
      

      case "Object":
        return (
          <div>
          <div>
            <div>
            <div
                style={{
                  position: 'absolute',
                  top: x+100,
                  left: y-15,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
            <Object width="45mm" height="auto" style={{position:"absolute",top:0,left:24,opacity:1}}/>
            <div
                style={{
                  position: 'absolute',
                  top: 113,
                  right: 36.2,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="5.2mm" height="auto"  />
                )}
              </div>
              <div style={{position:"absolute",top:309,right:33,display:"flex",justifyContent:"flex-end",alignItems:"center",width:50,height:15}}>
              <Cont width="3.235mm" height="auto" style={{marginTop:10}}/>

              <p className="zara-regular" style={{fontSize:"14pt",marginRight:2,marginLeft:1,marginBottom:-3}}>{sizeData.piecesNumber?.replace(/\s*x\s*/g, 'x')}</p>
              <Pieces width="3.922mm" height="auto" />

              </div>
    
<div
className="pdf-force"
style={{
  position: 'absolute',
  top: 195.4,
  left: 35.9,
  width: '145.8px',
  // debug için:
  // backgroundColor: 'rgba(255,0,0,0.15)',
}}
>
{/* İÇ KATMAN: yatay bastırma + genişlik telafisi */}
<div
  className="text-[3.5pt] leading-[3.8pt] text-justify pdf-force"
  style={{
    fontWeight: 400,
    fontSize: '3.8pt',
    lineHeight: '3.5pt',
    letterSpacing: '-0.25px',
    textAlign: 'justify',
    textJustify: 'inter-word',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    wordSpacing: '-0.3px',
    overflowWrap: 'break-word',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',

    // varsayılan dar yapı
    transform: 'scaleX(0.73) scaleY(1.13)',
    transformOrigin: 'left top',
    width: 'calc(145.8px / 0.73)',
  }}
>
  {/* description → kalsın */}
  <div style={{ display: 'block', marginBottom: '4.3px' }}>
    {getProductTextById(sizeData.description)}
  </div>

  {/* orta blok → daha geniş */}
  <div
    style={{
      display: 'block',
      marginBottom: '5.5px',

    }}
  >
    ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516
    FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S.
    SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL,
    QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.
  </div>

  {/* country translate → daha geniş */}
  <div
    style={{
      display: 'block',

    }}
  >
    {data.country.translate.map((i) => i.translation).join(' / ')}
  </div>
</div>






</div>

  <div
              style={{
                position: 'absolute',
                top: 7.5,
                left: 107.2,
                display: 'flex', // Flexbox kullanımı
      justifyContent: 'center', // Yatayda ortalama
      alignItems: 'center', // Dikeyde ortalama
      width:"30px",
      height:"30px",
  
              }}
            >

    
          <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexWrap: "nowrap",
    transition: "transform 0.3s ease",
    position: "absolute",
    width:82,

    top: 125.4,
    left:-7,
    height:25,

  }}
>
        <p
          className="arial-bold"
          style={{ marginRight: "4px",marginBottom:-6,marginLeft:-2.4 ,fontSize:"8pt"}}
        >
         EUR
        </p>
        <p
className='arial-regular'
style={{
  fontSize: "14pt",
  letterSpacing: "0",
  marginTop:"1px",
}}
>
       {integerPart}

        </p>
    {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
          <p
            className="arial-regular"
            style={{
              fontSize: "8pt",
              marginTop: "-5px",
              marginLeft: "1.8px",

              letterSpacing:"0"
            }}
          >
           {decimalPart}
          </p>
        )}
      </div>
    
              </div>
        
              
              <div></div>
           
    

     
         
    
             
              <div style={{ position: 'absolute', top: 111, left: 81 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>

    
         
     
              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 155.7, left: 76.8,width:"29.453mm",height:"11.971mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.767}
                  height={22.6}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={2}
                  fontSize={6.8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
           
            </div>
          </div>
        </div>
        );
      
        case "Basket":
          return (
            <div>
            <div>
              <div>
              <div
                style={{
                  position: 'absolute',
                  top: x+99.5,
                  left: y-14.6,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
              <Baskett width="45mm" height="auto" style={{position:"absolute",top:0,left:24,opacity:1}}/>
              <div
                  style={{
                    position: 'absolute',
                    top: 111,
                    right: 31.2,
      
                    justifyContent: 'center',
                    display: 'grid',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  {rifd && (
                    <ALARMHOME className="alarmIcon" width="5.2mm" height="auto"  />
                  )}
                </div>
      
<div
  className="pdf-force"
  style={{
    position: 'absolute',
    top: 237.4,
    left: 29.9,
    width: '156.8px',
    // debug için:
    // backgroundColor: 'rgba(255,0,0,0.15)',
  }}
>
  {/* İÇ KATMAN: yatay bastırma + genişlik telafisi */}
  <div
  className="text-[3.5pt] leading-[3.8pt] text-justify pdf-force"
  style={{

    fontWeight: 400,
    fontSize: '3.8pt',
    lineHeight: '3.5pt',
    letterSpacing: '-0.25px',
    textAlign: 'justify',
    textJustify: 'inter-word',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    wordSpacing: '-0.3px',
    overflowWrap: 'break-word',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',

    // 🔑 hem X hem Y transform
    transform: 'scaleX(0.738) scaleY(1.13)', // X %88, Y %112
    transformOrigin: 'left top',

    // genişliği telafi et → dışarı taşmasın
    width: 'calc(156.8px / 0.738)',
  }}
>
  <div style={{ display: 'block', marginBottom: '7px' }}>
    {getProductTextById(sizeData.description)}
  </div>

  <div style={{ display: 'block', marginBottom: '5.5px',letterSpacing:"-0.25px" }}>
    ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516
    FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S.
    SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL,
    QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.
  </div>

  <div style={{ display: 'block' }}>
    {data.country.translate.map((i) => i.translation).join(' / ')}
  </div>
</div>






</div>

    <div
                style={{
                  position: 'absolute',
                  top: 7.5,
                  left: 107.2,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
    
                }}
              >
          
      <div style={{ position: 'absolute', top: 202.6, left: -53,width:109.9,height:21.2}}>
              <div
                style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
              >
  
  <RenderIndoItemsCMKIDS indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />
  
  
              </div>
            </div>
      
            <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexWrap: "nowrap",
      transition: "transform 0.3s ease",
      position: "absolute",
      width:82,

      top: 124.6,
      left:-2,
      height:25
    }}
  >
          <p
            className="arial-bold"
            style={{ marginRight: "4px",marginBottom:-6,marginLeft:-2.4 ,fontSize:"8pt"}}
          >
           EUR
          </p>
          <p
className='arial-regular'
  style={{
    fontSize: "14pt",
    letterSpacing: "0",
    color: "black",
    marginTop:"1px",
  }}
>
          {integerPart}

          </p>
      {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
            <p
              className="arial-regular"
              style={{
                fontSize: "8pt",
                marginTop: "-5px",
                marginLeft: "2.2px",

                letterSpacing:"0"
              }}
            >
             {decimalPart}
            </p>
          )}
        </div>
      
                </div>
          
                
                <div></div>
             
      
  
       
           
      
               
                <div style={{ position: 'absolute', top: 110, left: 79 }}>
                {SelectedComponent && (
        <SelectedComponent.component
          width={SelectedComponent.width}
          height={SelectedComponent.height}
        />
      )}
      </div>

      
           
       
                <div style={{ position: 'absolute', top: -15, right: -21 }}>
                  {modifiedSvgText && (
                    <div
        dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
      
      ></div>
      
            )}
                </div>
        
             
         
                <div ref={barcodeRef} style={{ position: 'absolute', top: 155.4, left: 75.2,width:"29.453mm",height:"11.971mm"}}>
                  <Barcode
                    value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                    format="ITF14"
                    width={0.821}
                    height={24}
                    marginLeft={1}
                    marginRight={1}
                    marginTop={1}
                    marginBottom={1}  
                    background="transparent"
                    lineColor={isBlack ? '#ffffff' : '#000000'}
                    textMargin={2}
                    fontSize={7.28} // 7pt yaklaşık olarak 9px
                    font="Arial"
                  />
                </div>
      
       
             
              </div>
            </div>
          </div>
          );
          
          
          case "Food contact":
            return (
              <div>
              <div>
                <div>
                <div
                style={{
                  position: 'absolute',
                  top: x+100,
                  left: y-15,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>


                <Object width="45mm" height="auto" style={{position:"absolute",top:0,left:24,opacity:1}}/>
                <div
                    style={{
                      position: 'absolute',
                      top: 113,
                      right: 36.2,
        
                      justifyContent: 'center',
                      display: 'grid',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    {rifd && (
                      <ALARMHOME className="alarmIcon" width="5.2mm" height="auto"  />
                    )}
                  </div>
                  <div style={{position:"absolute",top:279.7,height:29,left:24.4,width:"169px",display:"flex",justifyContent:"flex-start",alignItems:"center"}}>
    <p className="zara-bold"
                    style={{
                      fontSize: "6.8pt",
                      lineHeight: "8.16pt",
                      letterSpacing: "0",
                      color: "black",
                      marginLeft:10.9
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="zara-bold"
                    style={{
                      fontSize: "6.8pt",
                      lineHeight: "8.16pt",
                      letterSpacing: "0",
                      color: "black",
                     marginLeft:3
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
                  <div style={{position:"absolute",top:267,left:35.5}}>
                  <Reg width="38.894mm" height="auto" />
                  </div>
                  <div style={{position:"absolute",top:309,right:33,display:"flex",justifyContent:"flex-end",alignItems:"center",width:50,height:15}}>
                  <Cont width="3.235mm" height="auto" style={{marginTop:10}}/>
    
                  <p className="zara-regular" style={{fontSize:"14pt",marginRight:2,marginLeft:1,marginBottom:-3}}>{sizeData.piecesNumber?.replace(/\s*x\s*/g, 'x')}</p>
                  <Pieces width="3.922mm" height="auto" />
    
                  </div>
        
    <div
    className="pdf-force"
    style={{
      position: 'absolute',
      top: 193.7,
      left: 35.5,
      width: '146.8px',
      // debug için:
      // backgroundColor: 'rgba(255,0,0,0.15)',
    }}
    >
    {/* İÇ KATMAN: yatay bastırma + genişlik telafisi */}
    <div
      className="text-[3.5pt] leading-[3.8pt] text-justify pdf-force"
      style={{
        fontWeight: 400,
        fontSize: '3.8pt',
        lineHeight: '3.8pt',
        letterSpacing: '-0.25px',
        textAlign: 'justify',
        textJustify: 'inter-word',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        wordSpacing: '-0.3px',
        overflowWrap: 'break-word',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',

        // varsayılan dar yapı
        transform: 'scaleX(0.73) scaleY(1.13)',
        transformOrigin: 'left top',
        width: 'calc(146.8px / 0.73)',
      }}
    >
 
    
      <div
        style={{
          display: 'block',
          marginBottom: '4.8px',
    
        }}
      >
        ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516
        FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S.
        SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL,
        QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.
      </div>
    
      {/* country translate → daha geniş */}
      <div
        style={{
          display: 'block',
          lineHeight: '3.5pt',

        }}
      >
        {data.country.translate.map((i) => i.translation).join(' / ')}
      </div>
    </div>
    
    
    
    
    
    
    </div>
    
      <div
                  style={{
                    position: 'absolute',
                    top: 7.5,
                    left: 107.2,
                    display: 'flex', // Flexbox kullanımı
          justifyContent: 'center', // Yatayda ortalama
          alignItems: 'center', // Dikeyde ortalama
          width:"30px",
          height:"30px",
      
                  }}
                >
    


              <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "nowrap",
        transition: "transform 0.3s ease",
        position: "absolute",
        width:82,
    
        top: 125.4,
        left:-7,
        height:25,
    
      }}
    >
            <p
              className="arial-bold"
              style={{ marginRight: "4px",marginBottom:-6,marginLeft:-2.4 ,fontSize:"8pt"}}
            >
             EUR
            </p>
            <p
    className='arial-regular'
    style={{
      fontSize: "14pt",
      letterSpacing: "0",
      marginTop:"1px",
    }}
    >
           {integerPart}
    
            </p>
        {sizeData?.mixed?.[0]?.currencyType !== "CLP" && (
              <p
                className="arial-regular"
                style={{
                  fontSize: "8pt",
                  marginTop: "-5px",
                  marginLeft: "1.8px",
    
                  letterSpacing:"0"
                }}
              >
               {decimalPart}
              </p>
            )}
          </div>
        
                  </div>
            
                  
                  <div></div>
               
        
    
         
             
        
                 
                  <div style={{ position: 'absolute', top: 111, left: 81 }}>
                  {SelectedComponent && (
          <SelectedComponent.component
            width={SelectedComponent.width}
            height={SelectedComponent.height}
          />
        )}
        </div>
    
        
             
         
                  <div style={{ position: 'absolute', top: -15, right: -21 }}>
                    {modifiedSvgText && (
                      <div
          dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
        
        ></div>
        
              )}
                  </div>
          
               
           
                  <div ref={barcodeRef} style={{ position: 'absolute', top: 155.7, left: 76.8,width:"29.453mm",height:"11.971mm"}}>
                    <Barcode
                      value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                      format="ITF14"
                      width={0.767}
                      height={22.6}
                      marginLeft={1}
                      marginRight={1}
                      marginTop={1}
                      marginBottom={1}  
                      background="transparent"
                      lineColor={isBlack ? '#ffffff' : '#000000'}
                      textMargin={2}
                      fontSize={6.8} // 7pt yaklaşık olarak 9px
                      font="Arial"
                    />
                  </div>
        
         
               
                </div>
              </div>
            </div>
            );
          

      default:
        // Eğer cardType yoksa veya tanınmıyorsa, mevcut renderShape'i kullan
        <></>
    }
  };
  

  return (
    <div>
    {renderCardTypeContent()}
    </div>
  )
}
